module.exports = __webpack_public_path__ + "static/usa-bcf09fe193a4ebebcba3e43f01d0769a.png";